export default "__VITE_ASSET__CLIdtC16__"